var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('h4',{staticStyle:{"display":"inline","margin-right":"-210px"}},[_vm._v("Getting applicant data...")]),_c('v-progress-circular',{attrs:{"indeterminate":"","size":"240"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }